import { render, staticRenderFns } from "./menuView.vue?vue&type=template&id=870ebc9e&scoped=true"
import script from "./menuView.vue?vue&type=script&lang=js"
export * from "./menuView.vue?vue&type=script&lang=js"
import style0 from "./menuView.vue?vue&type=style&index=0&id=870ebc9e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "870ebc9e",
  null
  
)

export default component.exports